import React from 'react'
import { Query } from 'react-apollo'
import { GET_PLAYLIST } from '../../graphql/queries'

const GetPlaylist = (WrappedComponent, fetchPolicy = 'cache-first') => {
  return class extends React.PureComponent {
    render() {
      return (
        <Query query={GET_PLAYLIST}
          variables={{ id: this.props.match.params.playlistId }}
          fetchPolicy={fetchPolicy}>
          {({ loading, error, data, refetch }) => {
            if (loading) {
              return null
            }

            if (error) {
              return `Error! ${error.message}`
            }

            if (data.getPlaylist === null) {
              return <h1 style={{ color: 'white', textAlign: 'center' }}>404</h1>
            }

            return (
              <WrappedComponent {...this.props} refetchPlaylist={refetch} playlist={data.getPlaylist} />
            )
          }}
        </Query>
      )
    }
  }
}

export default GetPlaylist

export const GetPlayListRefreshed = (WrappedComponent) => {
  return GetPlaylist(WrappedComponent, 'network-only')
}
